<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->

    <Banner
      title="Activity"
      subtitle="Activity"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">재능진로전공직업 탐색 프로젝트</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-read-wrap">
          <div>
            <ul class="line line4">
              <li>PUTT2.0기반 전공탐색 프로젝트</li>
              <li>
                <dl class="line2">
                  <dt>제목</dt>
                  <dd>“(지속 가능한 지구 살리기) 미래 도시를 건립하다!”</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <figure>
                  <n-space justify="center">
                    <img
                      src="@/assets/thum_img/kp708b/sub4_1/54131fa75a7288dcb2c757f455317ec8_water__c1_w280_h397.jpg"
                      alt=""
                    />
                  </n-space>
                </figure>
              </li>
              <li>
                <dl>
                  <dt>목적</dt>
                  <dd>
                    본 활동은 학생의 경험을 기반으로, 미래 최적의 재능을 발휘할
                    전공 탐색을 목적으로 한다.
                  </dd>
                </dl>

                <dl>
                  <dt>목표</dt>
                  <dd>
                    목표 1. (강의를 들으면서) 세상 이해 및 자기 이해를 통해
                    자기개념을 정립한다.<br />
                    목표 2. 팀 구성원 간 재능 및 관심을 소개, 공유, 논의 과정을
                    통해 전공 분야에 관한 인식을 다각적으로 탐색, 심화한다.<br />
                    목표 3. ‘미래 신도시 건립 프로젝트’ 참여를 위한 가상의 과제
                    제안서 작성을 통해 관심 전공을 면밀하게 탐색한다. <br />
                    목표 4. ‘목표 3’을 통해 팀 과업 과정에서 만나게 된 경험을
                    팀별로 발표하고, 개별 에세이를 작성, 제출한다.
                  </dd>
                </dl>

                <dl>
                  <dt>대상</dt>
                  <dd>고1 – 고3</dd>
                </dl>

                <dl class="line2">
                  <dt>시간</dt>
                  <dd>6시간 (사전 1시간ㅣ집합 5시간)</dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line line4">
              <li>JIGSAW 수업</li>
              <li>
                <dl class="line2">
                  <dt>재료</dt>
                  <dd>
                    •자료 1. 팀별 명단: PUTT2.0 결과를 기반으로, 팀(4인1팀)을
                    구성(팀 내, 유사한 재능 유형으로), 명단을 조직<br />
                    •자료 2. 활동지: ‘미래 도시 건립’ 사업의 수주를 위한
                    (가상)과업 제안서 (Worksheet. 1 – 4) <br />
                    •자료 3. 또래평가지: 다른 팀의 ‘과업제안서’ 평가에 사용할
                    ‘과업제안서 평가지’ (Worksheet. 5)<br />
                    •자료 4. 에세이 양식: “미래 글로벌 리더의 창조적 경험” 작성
                    (Worksheet. 6)
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>
                결과물<br />
                + PUTT2.0 결과리포트<br />
                + 팀 과업 제안서<br />
                + 발표 자료
              </li>
              <li>
                <dl class="line2">
                  <dt>구성</dt>
                  <dd>
                    • 모듈 1. [사전 진단] PUTT2.0 - 1주일 전 - On-Line 실시 – 팀
                    배치<br />
                    • 모듈 2. [강의] (1) PUTT2.0 결과 – 전공별 사례 소개, (2) 과제
                    소개 및 안전 교육<br />
                    • 모듈 3. [과제 수행] (1) 팀별 구성원 소개, (2) 전공 논의
                    (학과명/ 분야명/ 전문성 및 역량/ 주요 수업/ 산업체 등)
                    <br />
                    (3) 과제 논의 및 결정, (4) 개별 직무 및 조직 구성, 세부 내용
                    구성<br />
                    • 모듈 4. [제안서 및 에세이 작성] (1) 프로젝트 논의 및
                    제안서 작성, 발표 (2) 자기소개를 위한 에세이 작성
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line">
              <li>진행: 관리자</li>
              <li>
                <dl class="line2">
                  <dt>활용</dt>
                  <dd>
                    •전공 탐색을 통해 개인의 재능을 재구조화 하여 관심
                    분야에서의 경쟁력을 높임<br />
                    •’고교학점제’의 단중장기적 학업계획 수립을 위한 자신의 재능
                    구조 측정, 성장 예측, 전공선택 전략 수립에 유용
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div class="btn">
            <router-link :to="`${USER_ROUTES.Product.Activity.Talent.Path}`"
              >목록</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.menu-A-read-wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  word-break: keep-all;
  box-sizing: border-box;
}
.menu-A-read-wrap > div h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.menu-A-read-wrap > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu-A-read-wrap > div ul.box22 {
  padding: 20px 0;
}
.menu-A-read-wrap > div ul li {
  width: 100%;
  font-size: 14px;
  line-height: 1.7em;
}

.menu-A-read-wrap > div ul li:nth-child(1) {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}
.menu-A-read-wrap > div ul li dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 22px 0;
  border-bottom: 1px solid #ddd;
}

.menu-A-read-wrap > div ul li dl dt {
  width: 100%;
  margin-bottom: 10px;
}
.menu-A-read-wrap > div ul li dl dd {
  line-height: 1.7em;
  width: 100%;
}

.menu-A-read-wrap div.btn {
  margin-top: 50px;
  text-align: center;
}
.menu-A-read-wrap div.btn a {
  display: inline-block;
  text-align: center;
  font-size: 15px;
  background: #fff;
  color: #004e31;
  padding: 5px 25px;
  transition: all 0.2s;
  border: 1px solid #004e31;
  font-weight: 500;
}

@media (min-width: 768px) {
  .menu-A-read-wrap > div ul li dl {
    align-items: center;
  }
  .menu-A-read-wrap > div ul li dl.line3 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul.line {
    border-bottom: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li dl.line2 {
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul.line4 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 180px;
    padding: 0;
    text-align: center;
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 200px);
  }
  .menu-A-read-wrap > div ul li {
    font-size: 15px;
  }
  .menu-A-read-wrap > div ul li dl dt {
    width: 80px;
    margin-bottom: 0;
  }
  .menu-A-read-wrap > div ul li dl dd {
    line-height: 1.7em;
    width: calc(100% - 90px);
  }
}

@media screen and (min-width: 1100px) {
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 270px;
    padding: 0;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 320px);
  }
}
</style>
